import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/planificacion/importer/planificacionImporterActions';

export default importerReducers(actions);
